// extracted by mini-css-extract-plugin
export default {"base":"Mplayer_base__fHgEO","player__title":"Mplayer_player__title__DroKX","__player":"Mplayer___player__zEn9F"};